import { combineReducers } from 'redux';
import branding from '../../branding/reducer';
import caseDetails from '../../caseDetails/reducer';
import errorCode from '../../errorCode/reducer';
import fid from '../../fid/reducer';
import httpError from '../../httpError/reducer';
import pid from '../../pid/reducer';
import processCheck from '../../processCheck/reducer';
import redirectUrls from '../../redirectUrls/reducer';
import cookieConsent from '../../cookieConsent/reducer'

export const rootReducer = combineReducers({
  branding,
  caseDetails,
  cookieConsent,
  errorCode,
  fid,
  httpError,
  pid,
  processCheck,
  redirectUrls,
});

export type RootState = ReturnType<typeof rootReducer>;
